// width/height fuer ein <img> aus einer Upload-Referenz (Audit 2026-10-07, S5):
// der Browser reserviert die Flaeche, bevor das Bild geladen ist. Ohne Masse
// (alte Referenz, PDF, Fremdbild) keine Attribute — kein Raten.
export const bildMasse = (ref) =>
    ref && ref.width > 0 && ref.height > 0 ? { width: ref.width, height: ref.height } : {}
